const TARGET_ENV = process.env.ENV ? process.env.ENV.toUpperCase() : 'TEST';

type Environment = 'PRODUCTION' | 'S2' | 'LOCAL' | 'DOCKER' | 'DEV' | 'DEV_AA' | 'TEST' | 'E2E' | 'DEMO';
type ConfigProperty = 'BASE_DOMAIN' | 'BASE_URL' | 'API_URL' | 'API_URL_V2' | 'PUSHER_APP_KEY' | 'PUSHER_APP_CLUSTER' | 'IMAGE_PATH' | 'GOOGLE_MAP_KEY' | 'PUSH_NOTIFICATION_ID' | 'GOOGLE_ANALYTICS_ID' | 'FACEBOOK_APP_ID' | 'SENTRY_DSN' | 'HOMEOWNER_APP_URL';
type Config = Record<ConfigProperty, string>;
type ConfigGroup = Record<Environment,Config>;

const CONFIG_GROUP: ConfigGroup = {
  PRODUCTION: {
    BASE_DOMAIN: 'quartermaster.house',
    BASE_URL: 'https://www.quartermaster.house',
    API_URL: 'https://www.quartermaster.house/api',
    API_URL_V2: 'https://www.quartermaster.house/api/v2',
    PUSHER_APP_KEY: '583ba8f8bfe5513d0268',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e2cca5f6-d1a8-4630-b8c5-dc45e9e10452',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-1',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://36fe53673d1b48239345587b3a6e5340@sentry.io/1418191',
    HOMEOWNER_APP_URL: 'https://app.quartermaster.house',
  },
  S2: {
    BASE_DOMAIN: 's2.quartermaster.house',
    BASE_URL: 'https://s2.quartermaster.house',
    API_URL: 'https://s2.quartermaster.house/api',
    API_URL_V2: 'https://s2.quartermaster.house/api/v2',
    PUSHER_APP_KEY: '583ba8f8bfe5513d0268',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://s2.quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e2cca5f6-d1a8-4630-b8c5-dc45e9e10452',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-1',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://36fe53673d1b48239345587b3a6e5340@sentry.io/1418191',
    HOMEOWNER_APP_URL: 'https://app.s2.quartermaster.house',
  },
  LOCAL: {
    BASE_DOMAIN: 'localhost:9090',
    BASE_URL: 'http://localhost:9090',
    API_URL: 'http://localhost:9090/api',
    API_URL_V2: 'http://localhost:9090/api/v2',
    PUSHER_APP_KEY: '763bb523840c76affa85',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://dev-quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '210698936000992',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'http://localhost:4000',
  },
  DOCKER: {
    BASE_DOMAIN: 'localhost:9090',
    BASE_URL: 'http://localhost:9090',
    API_URL: 'http://localhost',
    API_URL_V2: 'http://localhost/v2',
    PUSHER_APP_KEY: '763bb523840c76affa85',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'http://localhost/storage/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '210698936000992',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'http://localhost:4000',
  },
  DEV: {
    BASE_DOMAIN: 'dev.quartermaster.space',
    BASE_URL: 'https://dev.quartermaster.space',
    API_URL: 'https://dev.quartermaster.space/api',
    API_URL_V2: 'https://dev.quartermaster.space/api/v2',
    PUSHER_APP_KEY: '763bb523840c76affa85',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://dev-quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'https://app.dev.quartermaster.space',
  },
  DEV_AA: {
    BASE_DOMAIN: 'dev-aa.quartermaster.space',
    BASE_URL: 'https://dev-aa.quartermaster.space',
    API_URL: 'https://dev-aa.quartermaster.space/api',
    API_URL_V2: 'https://dev-aa.quartermaster.space/api/v2',
    PUSHER_APP_KEY: '763bb523840c76affa85',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://dev-aa.quartermaster.space/storage',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'https://app.dev-aa.quartermaster.space',
  },
  TEST: {
    BASE_DOMAIN: 'test.quartermaster.space',
    BASE_URL: 'https://test.quartermaster.space/',
    API_URL: 'https://test.quartermaster.space/api',
    API_URL_V2: 'https://test.quartermaster.space/api/v2',
    PUSHER_APP_KEY: '763bb523840c76affa85',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://test-quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'https://app.test.quartermaster.space',
  },
  E2E: {
    BASE_DOMAIN: 'e2e.quartermaster.space',
    BASE_URL: 'https://e2e.quartermaster.space',
    API_URL: 'https://e2e.quartermaster.space/api',
    API_URL_V2: 'https://e2e.quartermaster.space/api/v2',
    PUSHER_APP_KEY: '763bb523840c76affa85',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://dev-quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'https://app.e2e.quartermaster.space',
  },
  DEMO: {
    BASE_DOMAIN: 'demo.quartermaster.space',
    BASE_URL: 'https://demo.quartermaster.space/',
    API_URL: 'https://demo.quartermaster.space/api',
    API_URL_V2: 'https://demo.quartermaster.space/api/v2',
    PUSHER_APP_KEY: 'ab240f17be3308f45814',
    PUSHER_APP_CLUSTER: 'mt1',
    IMAGE_PATH: 'https://demo-quartermaster.imgix.net/',
    GOOGLE_MAP_KEY: 'AIzaSyBhZd9-16F9B84ieJz2uFHdtZqqTfOKzdw',
    PUSH_NOTIFICATION_ID: 'e267a1c5-2f05-4541-8c6a-142da70dff30',
    GOOGLE_ANALYTICS_ID: 'UA-70083915-2',
    FACEBOOK_APP_ID: '1173057426078638',
    SENTRY_DSN: 'https://daf56bd547624308a6bfc430cb8968aa@sentry.io/1418206',
    HOMEOWNER_APP_URL: 'https://app.demo.quartermaster.space',
  },
};
let WORKING_CONFIG = CONFIG_GROUP[TARGET_ENV as Environment];

const static_base_url = WORKING_CONFIG.BASE_URL;

WORKING_CONFIG = {
  ...WORKING_CONFIG,
  get BASE_URL() {
    return window.location.origin || static_base_url;
  },
};
const DEFAULT_API_TIMEOUT = 16000;

const { API_URL, BASE_DOMAIN, BASE_URL, API_URL_V2 } = WORKING_CONFIG;

const { IMAGE_PATH } = WORKING_CONFIG;
const IMAGE_BASE_PATH = `${WORKING_CONFIG.BASE_URL}/storage/`;

export default {
  WORKING_CONFIG,
  DEFAULT_API_TIMEOUT,

  BASE_DOMAIN,
  BASE_URL,
  API_URL,
  API_URL_V2,
  API_TTL: 900000,

  SENTRY_DSN: WORKING_CONFIG.SENTRY_DSN,

  // image defaults
  IMAGE_API_ENDPOINT: `${API_URL}/temporary/image`,
  IMAGE_PATH,
  IMAGE_BASE_PATH,
  IMAGE_WIDTH: 1400,
  IMAGE_HEIGHT: 1400,

  QM_SUPPORT_PHONE: '647-977-5747',
  QM_SUPPORT_EMAIL: 'support@quartermaster.house',
};

// @ts-expect-error
export const includeDevTools = process.env.ENV.toUpperCase() !== 'PRODUCTION';
